module.exports = __webpack_public_path__ + "media/alert-sound.01fa19ca.wav";